import React, { memo, useCallback, useEffect, useRef, useState } from "react";

import CheckNotLogin from "@components/checkout/CheckNotLogin";
import Loading from "@components/Loading";
import { api } from "@utils/api";

import Items from "./Items";

const ShippingOptions = (props) => {
  const [isOpen, setOpen] = useState(true);
  const [data, setData] = useState({
    loading: true,
    availCountryMessage: {},
    showAvailCountry: false,
  });
  const shippingRef = useRef({});
  const {
    user,
    styles,
    session,
    dispatch,
    cartData,
    index,
    selectedAddress,
    item,
    selectedShippings,
    products,
    retailerId,
    isGuest = false,
    fecthShippingLoader = false,
  } = props;

  const handelCollapse = useCallback(() => {
    if (isOpen) {
      shippingRef.current.style.height =
        shippingRef.current.parentElement.clientHeight + "px";
      setTimeout(() => {
        shippingRef.current.style.height = "0px";
        setOpen((val) => !val);
      }, 10);
    } else {
      shippingRef.current.style.height = "auto";
      setOpen((val) => !val);
    }
  }, [isOpen]);

  const checkRetailerShipping = useCallback(async () => {
    if (item?.options.length > 0) {
      setData((preState) => ({ ...preState, loading: false }));
    } else {
      let productsIds = [];
      for (let item of products) {
        productsIds.push(item.product_id);
      }
      const shipingResult = await api(
        {
          url: "/cart/get-available-shiping-countries",
          method: "POST",
          data: {
            productId: productsIds,
            retailerId,
          },
        },
        session
      );
      let obj = {};
      if (shipingResult?.availableCountries?.length) {
        obj = {
          loading: false,
          showAvailCountry: true,
          availCountryMessage: `Sorry, this item can be shipped to ${shipingResult?.availableCountries} addresses only.`,
        };
      } else {
        obj = {
          loading: false,
        };
      }
      setData((preState) => ({ ...preState, ...obj }));
    }
  }, [item?.options, retailerId, session, products]);

  useEffect(() => {
    if (item?.retailer_id) {
      checkRetailerShipping();
    } else {
      setData((preState) => ({ ...preState, loading: fecthShippingLoader }));
    }
  }, [item?.retailer_id, fecthShippingLoader, checkRetailerShipping]);

  return (
    <div className="col-md-12 col-lg-6">
      {user || isGuest ? (
        <div className={styles.deliveryOptions}>
          {Object.keys(selectedAddress).length && item?.retailer_id ? (
            <div className={styles.deliveryHeading}>
              <div className={styles.destinationHd}>
                <h2>Delivery Options</h2>
              </div>
              <span
                className="card-link"
                data-toggle="collapse"
                aria-expanded={isOpen}
                onClick={handelCollapse}
              >
                {isOpen ? "-" : "+"}
              </span>
            </div>
          ) : (
            <div className={styles.destinationHd}>
              <h2>Delivery Options</h2>
            </div>
          )}

          {data.loading ? (
            <div className="pt-5 pb-5">
              <Loading.LineLoader />
            </div>
          ) : Object.keys(selectedAddress).length ? (
            <div
              ref={shippingRef}
              className={`collapse ${isOpen && "show"} ${
                styles.shippingOptions
              }`}
            >
              {item?.options.length ? (
                <Items
                  item={item}
                  user={user}
                  count={index + 1}
                  styles={styles}
                  session={session}
                  selected={selectedShippings[retailerId]}
                  dispatch={dispatch}
                  cartData={cartData}
                  isGuest={isGuest}
                  country={selectedAddress.country}
                />
              ) : data.showAvailCountry ? (
                <p>{data.availCountryMessage}</p>
              ) : (
                <>
                  <p>Sorry, there are no available delivery options.</p>
                  <p>
                    Please contact us at{" "}
                    <a href="mailto:support@betterthat.com">
                      support@betterthat.com
                    </a>
                  </p>
                </>
              )}
            </div>
          ) : (
            <div className={styles.deliverInfoBlock}>
              <div className={styles.deliveryOptions}>
                <div className={styles.destinationHd}>
                  <p className={styles.messageBelow}>
                    Delivery options will be displayed once you add an address
                    below.
                  </p>
                  <p className={styles.messageAbove}>
                    Delivery options will be displayed once you add an address
                    above.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <>{index === 0 && <CheckNotLogin isBag={true} />}</>
      )}
    </div>
  );
};

export default memo(ShippingOptions);
